import React, { useEffect, useRef, useState } from 'react';
import ClassesVideoList from '@/component/Classes/ClassesVideoList';
import Toast from '@/utils/toastManager';
import { useFetchClasses } from '@/data/swrs/classes';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '@/data/atoms/utilsAtoms';
import MobileViewFilters from '@/v2/pages/Lesson/components/MobileViewFilters';
import { useFilters } from '@/v2/hooks/useFilters';
import FilterSection from '@/component/Classes/FilterSection';
import {getUniqueTagsFromVideos} from '@/utils/getUniqueTagsFromVideos';

const ClassVideos = () => {
	const userData = useAtomValue(userInfoAtom);
	const [filteredProducts, setFilteredProducts] = useState([]);

	const {
		tags,
		setInstructors,
		products,
		selectedTags,
		selectedDurations,
		selectedLevels,
		selectedInstructors,
		selectedProducts,
		sortby,
		handleFilterChange,
		handleApplyFilter,
		handleResetFilter,
		isFilterModalOpen,
		handleOpenFilterModal,
		handleCloseFilterModal
	} = useFilters();

	const filters = {
		tags: selectedTags,
		durations:selectedDurations?.map(duration => duration).join(','),
		levels: selectedLevels,
		instructors: selectedInstructors,
		products: selectedProducts,
		sortby
	};

	const { videos, error, instructors, isLoading } = useFetchClasses(userData?.token, filters);


	useEffect(() => {
		if (videos && videos.length > 0) {
			
			const productIdsSet = new Set();
	
			videos.forEach(video => {
				video.products?.forEach(prod => {
					if (prod?._id) productIdsSet.add(prod._id);
				});
			});
			const filtered = products?.filter(p => productIdsSet.has(p.id));
			setFilteredProducts(filtered || []);
		}
	}, [videos, products]);
	
	useEffect(() => {
		if (error) {
			const errorMessage = error?.message || 'Something went wrong';
			Toast.error(errorMessage);
		}
	}, [error]);

	const initialFocusRef = useRef([])

	const uniqueTags = getUniqueTagsFromVideos(videos || [], initialFocusRef);

	return (
		<>
			<MobileViewFilters
				handleOpenFilterModal={handleOpenFilterModal}
				isFilterModalOpen={isFilterModalOpen}
				handleFilterChange={handleFilterChange}
				sortBy={sortby}
				tags={tags}
				selectedTags={selectedTags}
				selectedDurations={selectedDurations}
				selectedLevels={selectedLevels}
				selectedInstructors={selectedInstructors}
				selectedProducts={selectedProducts}
				handleApplyFilter={handleApplyFilter}
				handleResetFilter={handleResetFilter}
				handleCloseFilterModal={handleCloseFilterModal}
				instructors={instructors}
				products={filteredProducts}
			/>
			<div>
				<div className="tab-content fade-in" style={{ minHeight: '100vh' }}>
					<div id="menu2" className="tab-pane fade active show">
						<FilterSection
							category={'Classes'}
							handleOpenFilterModal={handleOpenFilterModal}
							handleFilterChange={handleFilterChange}
							sortby={sortby}
							isFilterModalOpen={isFilterModalOpen}
							tags={tags}
							selectedTags={selectedTags}
							selectedDurations={selectedDurations}
							selectedLevels={selectedLevels}
							handleApplyFilter={handleApplyFilter}
							handleResetFilter={handleResetFilter}
							handleCloseFilterModal={handleCloseFilterModal}
							selectedInstructors={selectedInstructors}
							instructors={instructors}
							products={filteredProducts}
							selectedProducts={selectedProducts}
						/>
						<ClassesVideoList videos={videos} isLoading={isLoading} />
					</div>
				</div>
			</div>
		</>
	);
};

export default ClassVideos;
